import { ComponentProps, memo } from 'react'
import { AccordionDetails as MuiAccordionDetails } from '@mui/material'

export interface AccordionDetailsProps extends ComponentProps<typeof MuiAccordionDetails> {}

const AccordionDetails = (props: AccordionDetailsProps) => {
  return <MuiAccordionDetails {...props} />
}

export default memo(AccordionDetails)
